import SupportProposal from './SupportProposal';
import {actions, connect} from '../../../stores';

const mapDispatchToProps = dispatch => ({
  resetState: () => dispatch(actions.auth.resetState()),
});

export default connect(null, mapDispatchToProps)(SupportProposal);